// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import PDesktopOutlinedSvg from "@fishx/icons-svg/es/asn/PDesktopOutlined";
import FishxIcon from '../components/FishxIcon';

var PDesktopOutlined = function PDesktopOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: PDesktopOutlinedSvg
  }));
};

PDesktopOutlined.displayName = 'PDesktopOutlined';
export default React.forwardRef(PDesktopOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/PDesktopOutlined.js
// module id = 3325
// module chunks = 0